/**
 * Favicon pre-warming for citation chips (InlineCitation).
 *
 * The chip's favicon is fetched from Google's favicon service at render time,
 * so it used to pop in AFTER the chip appeared. Search results arrive seconds
 * before the model writes the citations — preloading the favicons in that
 * window puts them in the browser cache, and the chip mounts with its icon
 * already there.
 */

const warmed = new Set<string>();

/** Hostname (without www.) for a URL or bare domain; '' when unparseable. */
export function extractDomain(urlOrDomain: string): string {
  if (!urlOrDomain) return '';
  let domain = urlOrDomain;
  if (urlOrDomain.includes('://')) {
    try {
      domain = new URL(urlOrDomain).hostname;
    } catch {
      return '';
    }
  }
  return domain.replace(/^www\./, '');
}

/** The exact favicon URL InlineCitation renders — same string, same cache entry. */
export function faviconUrlFor(domain: string): string {
  return `https://www.google.com/s2/favicons?domain=${domain}&sz=32`;
}

/** Warm the favicon cache for a URL/domain. Idempotent per domain. */
export function preloadFavicon(urlOrDomain: string): void {
  const domain = extractDomain(urlOrDomain);
  if (!domain || warmed.has(domain)) return;
  warmed.add(domain);
  try {
    const img = new Image();
    img.src = faviconUrlFor(domain);
  } catch {
    /* SSR/teste sem Image: só o dedupe importa */
  }
}
